import 'css-chunksrc/client/scenes/optimizedGantt/exportButton/styles.scss';export default {
  "wrapper": "_wrapper_18ocn_1",
  "exportButton": "_exportButton_18ocn_5",
  "text": "_text_18ocn_21",
  "icon": "_icon_18ocn_25",
  "dropdown": "_dropdown_18ocn_40",
  "dropdownItem": "_dropdownItem_18ocn_52"
};